import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ObraClasificacion } from '../../../types/ObraDetails';
import styles from './classification.module.scss';
import DataGroup from './dataGroup/dataGroup';
import technicalNoData from '../../../assets/technicalNoData.svg';
import NoDataPicture from '../components/noDataPicture/noDataPicture';
import ObrasAPI from '../../../services/APIObras';
import ErrorDetails from '../components/ErrorDetails/ErrorDetails';
import { ClassificationLoadingSkeleton } from './components/classificationLoadingSkeleton/classificationLoadingSkeleton';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ClassificationProps {
  codCentro: string;
  projectId?: string;
  projectIdLoading: boolean;
  projectIdError: boolean;
}

/* eslint-disable @typescript-eslint/no-non-null-assertion */
const Classification: FC<ClassificationProps> = (props) => {
  const { codCentro, projectId, projectIdLoading, projectIdError } = props;
  const [t] = useTranslation();
  const [classification, setClassification] = useState<ObraClasificacion>();
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const api = ObrasAPI.getInstance();
    setClassification(undefined);
    setLoadError(false);
    if (!projectId) return;

    api.getObraClassificationAPI(codCentro, projectId)
      .then((classificationResponse) => {
        setClassification({
          grupos: classificationResponse.grupos || [],
        });
      })
      .catch(() => {
        setLoadError(true);
      });
  }, [codCentro, projectId]);

  if ((!classification && loadError) || projectIdError) return <ErrorDetails />;
  if (!classification || projectIdLoading) return <ClassificationLoadingSkeleton />;

  const groups = classification.grupos || [];

  return (
    <div className={styles.containerGroup} data-testid="classification-test">
      {
        groups.length === 0 ?
          <NoDataPicture
            id='groups-noDataAdded'
            picture={technicalNoData}
            text={t('details.classification.noDataAdded')}
          />
          :
          <>
            <table>
              <tbody>
                {
                  groups.sort(
                    (a,b) => (a.origen > b.origen) ? 1: ((b.origen > a.origen) ? -1 : 0)
                  ).map((group, index) => {
                    return <DataGroup key={index} group={group} index={index} />;
                  })
                }
              </tbody>
            </table>
          </>
      }
      <div className='footer' style={{marginBottom: '75px'}}></div>
    </div>
  );
};

export default Classification;
